export default {
  // getHasManyItemsForEdit (objectClass, forClass, forId, forField, filters, queries) {
  //  return this.sendPostRequest('/api/' + objectClass + '/for/' + forClass +
  //    '/' + forId + '/' + forField, filters, queries)
  // },
}
